import React, { memo } from 'react'

import { bool } from 'prop-types'

import AdvancedFiltersContent from 'Pods/SearchPage/Shared/AdvancedFiltersContent/AdvancedFiltersContent'
import DatePublishedContent from 'Pods/SearchPage/Shared/DatePublishedContent/DatePublishedContent'
import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import PopoverFeaturesContent from 'Pods/SearchPage/Shared/PopoverFeaturesContent/PopoverFeaturesContent'
import QualityContent from 'Pods/SearchPage/Shared/QualityContent/QualityContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

// md (960-1279, Figma 415:23304): one scrollable column led by the Quality and License groups whose
// own dropdowns are hidden at this width.
function StackedSections({ showLgSlotOverflow = false, showDateOverflow = false, showDesignerSection = false }) {
  const translate = useTranslate()

  return (
    <>
      {showLgSlotOverflow && (
        <>
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.quality.title')}
          </div>
          <QualityContent hideQualityLabel />
          <div className="cgt-divider" aria-hidden="true" />
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.license.title')}
          </div>
          <LicenseContent hideGroupLabels />
          <div className="cgt-divider" aria-hidden="true" />
        </>
      )}
      {showDateOverflow && (
        <>
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.date_published.title')}
          </div>
          <DatePublishedContent />
          <div className="cgt-divider" aria-hidden="true" />
        </>
      )}
      {showDesignerSection && (
        <>
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.designers.title')}
          </div>
          {/* The popover's footer Reset clears designers, so the section hides its own. */}
          <DesignerContent hideReset />
          <div className="cgt-divider" aria-hidden="true" />
        </>
      )}
      <PopoverFeaturesContent />
      <AdvancedFiltersContent />
    </>
  )
}

StackedSections.propTypes = {
  showLgSlotOverflow: bool,
  showDateOverflow: bool,
  showDesignerSection: bool,
}

export default memo(StackedSections)
